import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-chat',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.css']
})
export class ChatComponent implements OnInit {

  @Input() message:string;
  @Input() class:string;
  @Input() class2:string;
  @Input() time:string;
  @Input() name:string;
  @Input() from:string;
  @Input() to:string;
  @Input() date:string;
  @Output() active: EventEmitter<boolean> = new EventEmitter();

  public image:string;
  constructor() { }

  ngOnInit() {
  //  this.image="";
  console.log("From:: "+this.from+"  To::  "+this.to);
  }

  OnClick(type:number)
  {
    console.log("Current event : "+type);
  }
  conts=[{icon:'home',number:'70422551144'},{icon:'work',number:'70422551144'}]
}
